<div class="row">
  <div class="requestCOIOuter stock-transfer-outer" (window:resize)="onresize($event)">
    <div class="request-coi-page sot-entry">
      <div class="row">
        <div class="col-md-10">
          <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a href="javascript:void(0)" (click)="navigateToLandingPage()">Stock Transfers</a>
                  <i class="fas fa-angle-right"></i>
                </li>
                <li class="breadcrumb-item breadcrumbColor xs-pr-0 active">
                  <span *ngIf="!sotRequestId || sotRequestId == 0">New Transfer Request</span>
                  <span id="spnBreadcrum" *ngIf="sotRequestId && sotRequestId>0">Transfer Request # {{orderNumber}}</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="col-md-2 text-right">
          <div class="pt-2">
            <div>
              <ul *ngIf="isEditMode && isHeaderButtonsEnable()">
                <li matTooltip="Pdf" class="pdf-icon margin-r10 cursor" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" (click)="generatedPdf(sotRequestId)">
                </li>
                <li class="mail-icon margin-r10 cursor" matTooltip="Email" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" (click)="emailOrderDetail(sotRequestId)">
                </li>
                <li (click)="openRequestHistorySlider()" class="clock-icon cursor d-none d-md-inline-block" matTooltip="Request History" matTooltipClass="whiteFontCpp" [matTooltipPosition]="'above'">
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="returnTop xs-mb-5 addShadowForMobile">
        <div>
          <div class="row">
            <!--From Ship To Select List-->
            <div class="ml-lg-5 ml-md-0 col-12 col-md-6 material-select sotTransferFromAccount withBordr">
              <ng-select name="ddlFromShipTo"
                         [items]="fromShipToAccountItems"
                         class="custom-select-grower grower-add-drop cpp-return-shipto pb-1"
                         [virtualScroll]="true"
                         [(ngModel)]="fromShipToAccount"
                         [disabled]="isEditMode || readOnlyAccess"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         placeholder="Transfer From Account:*"
                         [loading]="fromShipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getDeliverTo($event)"
                         (clear)="getDeliverTo($event)">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12 mb-2">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0 py-1">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0 py-1" *ngIf="item.primaryPhoneNumber !== null">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div class="border-line pb-2">
                          Account To #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div class="col-12 col-md-5">
              <div class="row padding-t15" *ngIf="fromShipToAccount">
                <div class="col-6 col-md-5 transferAccount padding-t0">
                  Transfer To Account:*
                </div>
                <div class="col-6 col-md-6" *ngIf="!readOnlyAccess">
                  <p><a id="aToSelectAccount" class="selectLink" (click)="fromShipToAccount ? selectAccount():''">Click to Select Account</a></p>
                </div>
              </div>
              <div class="row padding-t15" *ngIf="!fromShipToAccount">
                <div class="col-6 col-md-5 transferToAccount padding-t0">
                  Transfer To Account:*
                </div>
                <div class="col-6 col-md-6" *ngIf="!readOnlyAccess">
                  <p><a id="aToSelectAccount" class="selectLink transferToSelectLink" (click)="fromShipToAccount ? selectAccount():''">Click to Select Account</a></p>
                </div>
              </div>
              <div class="lineHeight">
                <div class="mb-0 mt-1" *ngIf="toAccountName">{{toAccount?.accountName}}</div>
                <div class="mb-0 py-1" *ngIf="toAccountName">{{toAccount?.address1}},  {{toAccount?.city}}, {{toAccount?.state}} - {{toAccount?.zipCode}}</div>
                <div class="pb-2 border-line" *ngIf="toAccountName">Account #: {{toAccount?.accountNumber}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Delivery Option-->
      <div class="returnTop xs-pb-0">
        <div class="row">
          <div class="col-12 col-md-3 radio-label">
            <label id="example-radio-group-label" class="col-10">
              DELIVERY OPTIONS:
            </label>
            <div (click)="toggleDeliveryMobile()" class="xs-expand-none text-center left-sm-5 d-block d-md-none col-2">
              <i class="fa angle" [ngClass]="isExpandedDeliveryMobile ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </div>
          </div>
          <div class="col-12 col-md-9" [@detailExpandDeliveryMobile]="isExpandedDeliveryMobile ? 'collapsedDeliveryMobile' : 'expandedDeliveryMobile'">
            <mat-radio-group aria-labelledby="example-radio-group-label"
                             class="example-radio-group"
                             [(ngModel)]="deliveryOption">
              <mat-radio-button class="custom-radio " *ngFor="let delivery of deliveryOptionList" [value]="delivery.id"
                                [disabled]="(delivery.id==4 && disableWFUArranged?true:false) ||
                                ((delivery.id==1 || delivery.id==2) && disableAlreadyMovedToOrFrom?true:false) ||
                                (readOnlyAccess && delivery.id!=deliveryOption)"
                                matTooltip="Your order does not meet current shipment requirement, please contact Winfield United Customer Service +1.855.494.6343."
                                [matTooltipPosition]="'below'"
                                [matTooltipDisabled]="(delivery.id == 4 && !disableWFUArranged) ||
                                  ((delivery.id==1 || delivery.id==2) && !disableAlreadyMovedToOrFrom) || delivery.id==3 || readOnlyAccess ">
                {{delivery.value}}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!--Pickup Information Section  [ngClass]="!isAddProductEnable ? 'disabled-icon' : ' '"-->
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0">
          Pickup Information: <span class="xs-ml-5 flex-one">(From Account)</span> <span (click)="togglePickup()" class="xs-expand-none xs-mr-20">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
        <div class="row" [@detailExpand]="isExpanded ? 'collapsed' : 'expanded'">
          <div class="col-lg-3 col-md-6">
            <div class="text-center deliveryDatePicker required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Desired Pickup Date</mat-label>
                <input matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter" [(ngModel)]="fromDesiredPickupDate" [min]="minDate" #dateName="ngModel"
                       name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');" [disabled]="readOnlyAccess"
                       required (change)="desiredPickupDateValid(dateName)" (dateChange)="ValidateSelectedDesiredPickupDate($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker>
                  <div #datepickerFooter>
                    <div class="row border-top m-0">
                      <div class="col-sm-5 col-5 pr-0">
                        <div class="p-1 ">
                          <span class="white-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Today's Date
                          </span>
                        </div>
                        <div class="p-1">
                          <span class="green-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Requested Delivery
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div class="padding-top80">
              <div class="requiredText">*required when Delivery Option "WFU Arranged" is selected</div>
              <div><span class="redAsktrik">*</span><span>always required</span></div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 ">
            <div class="required-input-field blueAstrick">
              <mat-form-field class="wide100">
                <mat-label>Contact Name :</mat-label>
                <input matInput type=text name="ContactName"
                       
                       autocomplete="new-username"
                       [(ngModel)]="fromContactName"
                       [disabled]="readOnlyAccess"
                       maxlength="15"
                       required
                       #name="ngModel"
                       (change)="nameShouldBeValid(name)" />
              </mat-form-field>
            </div>
            <div class="required-input-field blueAstrick">
              <mat-form-field class="wide100">
                <mat-label>Contact Number :</mat-label>
                <input matInput type=text name="ContactNumber"
                       autocomplete="new-username"
                       [(ngModel)]="fromContactNumber"
                       [disabled]="readOnlyAccess"
                       mask="000-000-0000"
                       #phone="ngModel"
                       required
                       (change)="phoneShouldBeValid(phone)" />
                <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
            <div class="not-required-input">
              <mat-form-field class="wide100">
                <mat-label>Customer PO Number :</mat-label>
                <input matInput type=text name="CustomerPONumber"
                       autocomplete="new-username"
                       [disabled]="readOnlyAccess"
                       [(ngModel)]="fromCustomerPONumber"
                       maxlength="25" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 material-select withBordr not-required-select">
            <ng-select name="ddlFromDeliveryAccount"
                       [items]="deliveryAccountList"
                       class="custom-select-grower  grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="fromDeliveryAccount"
                       [disabled]="!deliverToAnotherLocation || readOnlyAccess"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Pickup Location:"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div>
              <mat-checkbox class="custom-checkbox pr-2"
                            [disabled]="readOnlyAccess"
                            [style.display]=""
                            [checked]=""
                            [indeterminate]=""
                            (change)="updateDeliverToSelection($event.checked)"
                            [(ngModel)]="deliverToAnotherLocation"></mat-checkbox>
              <label class="checkbox-color">If Pickup Location is different than From Account.</label>
            </div>
            <div>
              <label for="specialInst" class="checkbox-color mb-0">Shipping Instructions:</label>
              <mat-form-field class="example-full-width specialInst mt-0 d-block" floatLabel="never">
                <textarea style="resize:none;height:auto; width: 100%" matInput rows="6" id="txtShippingInstructions"
                          [(ngModel)]="fromShippingInstructions"
                          [disabled]="readOnlyAccess"
                          appearance="fill"
                          [maxLength]="500"
                          [readonly]="readOnlyAccess"
                          placeholder="up to 500 characters"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr">
            <div class="freight-dd">
              <label>Freight Instructions:</label>
              <div class="dd-scroll">
                <mat-selection-list #freightInstructionCtrl [(ngModel)]="selectedFreightInstructionOptions">
                  <mat-list-option *ngFor="let item of freightInstruction; let i = index;" [value]="item" [disabled]="readOnlyAccess">
                    {{item.value}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
            <div class="row">
              <div class="col-3 col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <mat-label>Non Stock Pallet :</mat-label>
                  <input matInput type="text" name="NonStockPallet"
                         autocomplete="new-username"
                         [(ngModel)]="fromNonStockPallet"
                         [disabled]="readOnlyAccess"
                         required
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count="ngModel"
                         (change)="countShouldBeValid(count)" />
                  <mat-error *ngIf="count.invalid && (count.dirty || count.touched)">Please enter the number of Non Stock Pallet being transferred</mat-error>
                </mat-form-field>
              </div>
              <div class="col-3 col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <mat-label>Stock Pallet :</mat-label>
                  <input matInput type="text" name="StockPallet"
                         autocomplete="new-username"
                         [(ngModel)]="fromStockPallet"
                         [disabled]="readOnlyAccess"
                         required
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count1="ngModel"
                         (change)="countShouldBeValid(count1)" />
                  <mat-error *ngIf="count1.invalid && (count1.dirty || count1.touched)">Please enter the number of Stock Pallet being transferred</mat-error>
                </mat-form-field>
              </div>
              <div class="col-6 col-md-12 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <mat-label>Empty CBox :</mat-label>
                  <input matInput type="text" name="CBox"
                         autocomplete="new-username"
                         [(ngModel)]="fromCBox"
                         [disabled]="readOnlyAccess"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         required
                         #count2="ngModel"
                         (change)="countShouldBeValid(count2)" />
                  <mat-error *ngIf="count2.invalid && (count2.dirty || count2.touched)">Please enter the number of Empty CBox being transferred</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Delivery Information-->
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0 text-fade">
          Delivery Information: <span class="xs-ml-5 flex-one">(To Account)</span> <span (click)="togglePickupDelivery()" class="xs-expand-none xs-mr-20">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
      </div>

      <!--Rejection Reason -->
      <div class="returnTop d-flex" *ngIf="requestStatus=='REJECTED'">
        <label style="color:red; margin-bottom: 0;">This request has been rejected for the following reason:</label>
        <textarea style="resize: none; height:auto; border: none; padding: 0 15px; width: 75%; " matInput
                  [(ngModel)]="rejectionReason"
                  appearance="fill"
                  [maxLength]="3000"       
                  [readonly]="true"></textarea>
      </div>

      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="addProdContent">

          <div *ngIf="isFilterAddProductShow" class="grower-add-sec seed-return-filter">
            <div class="row listing-action-items grower-page">
              <div class="col-12 col-md-9">
                <mat-checkbox *ngIf="isAddProductEnable" #AllProductCheck class="custom-checkbox select-all-check"
                              [checked]="isAllProductChecked"
                              [style.display]="disablecheckbox ? 'none' : 'block'"
                              [indeterminate]="checkBoxCount > 0 && !isAllProductChecked"
                              [disabled]="readOnlyAccess"
                              (change)="enableAllCheckBoxes(!isAllProductChecked)"
                              title="Select All Lines"></mat-checkbox>
                <div class="product-filter-outer" [ngClass]="disablecheckbox ? 'margin-sm-l0':'margin-sm-l25'">
                  <div class="product-filter col-md-12" *ngIf="!editToolKit || checkBoxCount<=0 || isSearchClicked">
                    <div class="search-category">
                      <div class="brand-dropdown default-select">
                        <ng-select [disabled]="readOnlyAccess" [items]="searchTypeList"
                                   name="ddlProductSearch"
                                   [(ngModel)]="productSearchFilter"
                                   [virtualScroll]="true"
                                   [closeOnSelect]="true"
                                   [selectOnTab]="true"
                                   [clearable]="false"
                                   bindLabel="name"
                                   bindValue="value"
                                   [searchable]="false"
                                   (change)="keepFilter()"
                                   placeholder="Select Category">
                        </ng-select>
                      </div>
                    </div>
                    <div class="search-box">
                      <div class="row margin-t5 margin-r0 margin-b5 margin-l0">
                        <div class="default-select select-container">

                          <div *ngIf="productSearchFilter === 'productName'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectProductName($event)" (blur)="selectProductName($event)" [(ngModel)]="productFilters.productName" placeholder="Search...">
                              </div>
                            </div>
                          </div>
                          <div *ngIf="productSearchFilter === 'lotNumber'">
                            <div class="searchInputBox">
                              <span class="search-icon">
                                <i class="fas fa-search"></i>
                              </span>
                              <div class="select-container">
                                <input (keyup.enter)="selectLotNumber($event)" (blur)="selectLotNumber($event)" [(ngModel)]="productFilters.lotNumber" placeholder="Search...">
                              </div>
                            </div>
                          </div>

                          <!--Package Size Search box-->
                          <ng-select #packageSize name="ddlpackageSizeSearch" *ngIf="productSearchFilter === 'packageSize'"
                                     [items]="packageSizeMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.packageSize"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <!--Product Line Search box-->
                          <ng-select #productSearch name="ddlproductLineSearch" *ngIf="productSearchFilter === 'productLine'"
                                     [items]="productLineList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.productLine"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <!--Item Number Search box-->
                          <ng-select #itemNumberSearch name="ddlitemNumberSearch" *ngIf="productSearchFilter === 'itemNumber'"
                                     [items]="invoicedProductList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.invoicedProductList"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <!--Marketing Brand Search box-->
                          <ng-select #marketingBrand name="ddlMarketingBrandSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                                     [items]="marketingBrandMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.marketingBrand"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>

                          <!--Treatment Search box-->
                          <ng-select #treatment name="ddlTreatmentSearch" *ngIf="productSearchFilter === 'treatmentDescription'"
                                     [items]="treatmentMasterList"
                                     placeholder="Search"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.treatmentDescription"
                                     [virtualScroll]="true"
                                     bindLabel="value"
                                     bindValue="value"
                                     [closeOnSelect]="true"
                                     [searchFn]="filterSearchFn"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <p class="name">
                                      {{item.value}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row chips-sec" *ngIf="(!editToolKit || checkBoxCount<=0 || isSearchClicked) && filterValueList != ''">
                    <div class="col-9 col-md-10 selected-chip">
                      <div>
                        <mat-chip-set>
                          <mat-chip selected *ngFor="let filterValue of filterValueList">
                            {{filterValue}}
                            <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                              <i class="fas fa-times text-right"></i>
                            </a>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>
                    <div class="col-3 col-md-2 text-right">

                      <a href="Javascript:void(0);" *ngIf="filterValueList.length > 0" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                    </div>
                  </div>
                </div>

                <div class="product-tools-tab" *ngIf="showTabs && (!isSearchClicked && editToolKit)" appClickOutside (clickOutside)="tabNode=''">
                  <div class="tab-bar">
                    <ul>
                      <li *ngIf="(isValidLineStatus && !readOnlyAccess)" (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Products" [matTooltipPosition]="'above'">
                        <i class="icon-ico-trash"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div *ngIf="tabNode==='delete'" class="delete-product">
                      <div class="tab-content-heading">
                        For: {{selectedAccountName}}
                      </div>
                      <div class="tab-content-detail">
                        <p>Are you sure you want to delete <span> {{checkBoxCount}} </span> selected Items(s)?</p>
                        <div class="btn-area">
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                          <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-3 text-right">
                <div class="row">
                  <!--<div class="col-md-2 text-left padding-l0">-->
                  <!--<div class="col-md-12 col-lg-12 smallPadRgt0">-->
                  <!--<app-filter [optionsData]="filterOptionsData" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>-->
                  <!--<cppfilter [filters]="filterTypeList" (onSearchFilter)="filterProductGridData($event)" (onClearFilter)="clearGridData($event)"></cppfilter>-->
                  <!--</div>-->
                  <!--<ul class="padding-t10">
                    <li *ngIf="checkBoxCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                      <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'"></i>
                    </li>
                  </ul>-->
                  <!--</div>-->
                  <div class="col-12 text-center margin-sm-t10 padding-sm-l0 padding-sm-r0">
                    <button id="btnAddProduct" mat-raised-button class="btns wide-sm-100 height-md-44" [disabled]="!isAddProductEnable || readOnlyAccess" (click)="addProduct()">Add Product</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="OrderReleaseTop">
            <div class="row">
              <div class="col-md-12">
                <div class="tableContainer prodTableContainer sotEntryTable">
                  <!--<table mat-table [dataSource]="productItemsDataSource" multiTemplateDataRows class="matTables productTable">-->
                  <table mat-table #requestTable [dataSource]="productItemsDataSource" multiTemplateDataRows class="matTables seedCropLossTable">

                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'">
                      <th mat-header-cell *matHeaderCellDef class="colCheckBox"></th>
                </div>

                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="sotNameBlock pl-0">Product Name</th></div>
                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="sotPacksize text-center">Pack Size</th></div>
                <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="sotPacksize text-center">Lot Number</th></div>
                <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="sotPacksize text-center">Treatment</th></div>
                <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="sotPacksize text-center">Product Line</th></div>
                <div *ngIf="column=='availability'"><th mat-header-cell *matHeaderCellDef class="sotPacksize text-center">Availability</th></div>
                <div *ngIf="column=='requestedQty'"><th mat-header-cell *matHeaderCellDef class="sotRequestQty text-center">Requested QTY</th></div>

                <!--<div *ngIf="column=='problemDescription'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>-->
                <!--id="replantProductTbl_error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}"-->
                *
                <td mat-cell *matCellDef="let element" class="position-relative">

                  <div *ngIf="column=='checkbox'">
                    <div class="lineitem-symbols"></div>
                  </div>
                  <div *ngIf="column=='checkbox' && !readOnlyAccess && isAddProductEnable" class="text-center" matTooltip="Select Product" [matTooltipPosition]="'above'">

                    <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck._checked, false); element.isSelected=SingleCheck._checked;"
                                  [(ngModel)]="element.isSelected"
                                  class="pt-2 custom-checkbox custom-Singlecheckbox"></mat-checkbox>
                  </div>

                  <div *ngIf="column=='product'" class="order-info-outer">
                    <div class="order-info ml-0">
                      <div class="d-block d-md-none">Product Name</div>
                      <p class="prod-id">{{element.itemVendorName}}</p>
                      <p class="prod-name" [matTooltipPosition]="'above'">{{element.itemDescription}}</p>
                      <p class="prod-num">{{element.itemNumber}}</p>
                    </div>
                  </div>

                  <div *ngIf="column=='packageSize'" class="measureUnit text-center  font-14">
                    <div class="d-block d-md-none">Pack Size</div>
                    <p class="mb-0"> {{element.packageSize}} </p>
                  </div>

                  <div *ngIf="column=='lotNumber'" class="measureUnit text-left text-md-center  font-14">
                    <div class="d-block d-md-none">Lot Number</div>
                    <p class="mb-0"> {{element.lotNumber}} </p>
                  </div>

                  <div *ngIf="column=='treatment'" class="measureUnit text-center  font-14">
                    <div class="d-block d-md-none">Treatment</div>
                    <p class="mb-0"> {{element.treatment}} </p>
                  </div>

                  <div *ngIf="column=='productLine'" class="measureUnit text-center  font-14">
                    <div class="d-block d-md-none">Product Line</div>
                    <p class="mb-0"> {{element.productLine}} </p>
                  </div>

                  <div *ngIf="column=='availability'" class="measureUnit text-center  font-14">
                    <div class="d-block d-md-none">Availability</div>
                    <p class="mb-0"> {{element.availableQuantity}} </p>
                  </div>

                  <div *ngIf="column=='requestedQty' && !readOnlyAccess" class="measureUnit text-center  font-14">
                    <div>
                      <div class="d-block d-md-none margin-md-b10">Requested QTY</div>
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isDecreaseQtyDisable" [attr.data-testid]="'decrease-' + element.itemNumber" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element)"> - </button>
                      <input id="txtRequestedQty_{{element.itemNumber}}" [readonly]="readOnlyAccess" [attr.data-testid]="'qty-' + element.itemNumber" [disabled]="element.isDecreaseQtyDisable || element.isIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="textChange(element)" [(ngModel)]="element.requestedQty" maxlength="5" appNumbersOnly [ngClass]="{'invalid-txt': (element.requestedQty==0 || element.requestedQty=='')}" />
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isIncreaseQtyDisable" [attr.data-testid]="'increase-' + element.itemNumber" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element)"> + </button>
                    </div>
                  </div>
                  <div *ngIf="column=='requestedQty' && readOnlyAccess" class="measureUnit text-center  font-14">
                    <p class="mb-0"> {{element.requestedQty}} </p>
                  </div>
                  <!--<div *ngIf="column=='unitsCredited'" class="quantityBlock text-center">
                    <div>
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isUnitsCreditedDecreaseQtyDisable" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element,'unitsCredited', false)"> - </button>
                      <input [readonly]="readOnlyAccess" [disabled]="element.isUnitsCreditedDecreaseQtyDisable || element.isUnitsCreditedIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element, 'unitsCredited', false)" [(ngModel)]="element.unitsCredited" maxlength="5" appNumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                      <button *ngIf="!readOnlyAccess" [disabled]="element.isUnitsCreditedIncreaseQtyDisable" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element,'unitsCredited', false)"> + </button>
                    </div>
                  </div>-->
                </td>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details p-0" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error m-0" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}">
                      <div class="row">
                        <div class="col-md-9">
                          <!--<ol class="error-list">-->
                          <ol>
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="newlineMsg" *ngIf="element.warningMessage" id="warning_{{element.itemId}}">
                      <div class="row">
                        <div class="col-md-12">
                          {{element.warningMessage}}
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row d-none d-md-table-row"></tr>
                </table>
                <div *ngIf="productItemsDataSource == undefined || productItemsDataSource?.data?.length == 0" class="noDataMsg">
                  <p>No Record Found.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Error section on table-->
      <div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
        <div class="row">
          <div class="col-md-2 padding-r0 errCountOuter">
            <span class="errorCounting">
              {{currentErrorRow}} of {{errorMsgs.length}}
            </span>
          </div>
          <div class="col-md-6 padding-l0 ">
            <ul class="errorMsg">
              <li *ngFor="let err of errorMsgs[index].errors">
                <p class="padding-10"> {{err.error}}</p>
              </li>
            </ul>
          </div>
          <div class="col-md-4 button-sec text-right">
            <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
            <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
          </div>
        </div>
      </div>

      <div class="SeedFulfillBtnSec">
        <div class="row padding-l20 padding-sm-l0">
          <div class="col-12 col-md-8">
            <div class="row">
              <div class="col-12 col-md-3 padding-sm-5" *ngIf="!readOnlyAccess && requestStatus != 'REJECTED' && requestStatus != 'APPROVED' && requestStatus != 'CANCELLED' && requestStatus != 'COMPLETED'">
                <button mat-raised-button class="btns wide100" [disabled]="!isSubmitEnable" (click)="saveRequest('SUBMITTED')" [style.display]="'inline-block'" id="btnSubmitRequest">Submit Request</button>
              </div>
              <div class="col-6 col-md-2 padding-sm-5" *ngIf="!readOnlyAccess && requestStatus != 'REJECTED' && requestStatus != 'APPROVED' && requestStatus != 'CANCELLED' && requestStatus != 'EDITING' && requestStatus != 'COMPLETED'">
                <button mat-raised-button class="btns wide100" [disabled]="!isDraftEnable" (click)="saveRequest('DRAFT')" [style.display]="'inline-block'" id="btnSaveDraft">Save Draft</button>
              </div>
              <div class="col-6 col-md-2 padding-sm-5" *ngIf="!readOnlyAccess && requestStatus == 'REJECTED'">
                <button mat-raised-button class="btns wide100" [disabled]="!isSubmitEnable" (click)="openResolutionDialog(requestStatus)" [style.display]="'inline-block' ">Continue</button>
              </div>
              <div class="col-6 col-md-2 padding-sm-5" *ngIf="!readOnlyAccess && isEditingOrRejected">
                <button mat-raised-button class="btns wide100" [disabled]="!isSubmitEnable" (click)="saveRequest(requestStatus)" [style.display]="'inline-block' ">Save</button>
              </div>
              <div class="col-md-3 padding-sm-5" [ngClass]="readOnlyAccess && requestStatus == 'COMPLETED' ||  requestStatus == 'REJECTED' ||  requestStatus == 'CANCELLED' ? 'col-12':'col-6'">
                <button mat-raised-button class="btns wide70 wide-sm-100" (click)="navigateToLandingPage()" color="primary" [style.display]="'inline-block'">Close</button>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right padding-md-t10">
            <span class="count">Requested Products <span>{{filteredDataCount}}</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
